import { combineReducers } from "@reduxjs/toolkit";
import investorReducer from "./investor/slice";
import mqttReducer from "./mqtt/slice";
import subscriptionReducer from "./subscription/slice";
import systemReducer from "./system/slice";

const createRootReducer = () => {
	return combineReducers({
		investor: investorReducer,
		system: systemReducer,
		subcription: subscriptionReducer,
		mqttConnection: mqttReducer,
	});
};

export default createRootReducer;
